import React, { useState, useEffect } from "react";
import { Table, Pagination, Button, Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import SidebarLayout from "../../components/sidebarLayout";
import menuData from "../../data/menuData"; // 메뉴 데이터 가져오기
import axios from "axios"; // Axios 추가
import "./qna.css"; // 스타일 가져오기

const ITEMS_PER_PAGE = 10; // 페이지당 항목 수

export default function QnA() {
  const [currentPage, setCurrentPage] = useState(1); // 현재 페이지 상태
  const [qnaList, setQnaList] = useState([]); // Q&A 데이터 상태
  const [loading, setLoading] = useState(true); // 로딩 상태
  const [error, setError] = useState(null); // 에러 상태
  const qnaMenu = menuData.find((menu) => menu.title === "포럼소식");
  const navigate = useNavigate();

  useEffect(() => {
    // Q&A 데이터 가져오기
    const fetchQnAList = async () => {
      setLoading(true);
      try {
        const response = await axios.get("/api/qna/list");
        setQnaList(response.data.data || []); // 서버에서 받은 데이터를 상태에 저장
      } catch (err) {
        console.error("Error fetching Q&A list:", err);
        setError("Q&A 데이터를 가져오는 중 오류가 발생했습니다.");
      } finally {
        setLoading(false);
      }
    };

    fetchQnAList();
  }, []);

  // 총 페이지 수 계산
  const totalPages = Math.ceil(qnaList.length / ITEMS_PER_PAGE);

  // 현재 페이지에 해당하는 Q&A 계산
  const currentQnA = qnaList.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  // 페이지 변경 핸들러
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  if (loading) {
    return <p className="text-center">로딩 중...</p>;
  }

  if (error) {
    return <p className="text-center text-danger">{error}</p>;
  }

  return (
    <div>
      <SidebarLayout menu={qnaMenu}>
        {/* Q&A 테이블 */}
        <Table className="qna-table" striped hover>
          <thead>
            <tr>
              <th className="text-center" style={{ width: "10%" }}>
                번호
              </th>
              <th>제목</th>
              <th className="text-center" style={{ width: "15%" }}>
                작성자
              </th>
              <th className="text-center" style={{ width: "15%" }}>
                작성일자
              </th>
            </tr>
          </thead>
          <tbody>
            {currentQnA.map((qna, index) => (
              <tr key={qna.qnaId}>
                <td className="text-center">
                  {(currentPage - 1) * ITEMS_PER_PAGE + index + 1}
                </td>
                <td>
                  <Link to={`/qna/${qna.qnaId}`} className="qna-link">
                    {qna.title}
                  </Link>
                </td>
                <td className="text-center">{qna.nameKor}</td>
                <td className="text-center">
                  {new Date(qna.createdAt).toLocaleDateString("ko-KR")}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        {/* 글작성 버튼 */}
        <Row className="mb-3">
          <Col className="text-end">
            <Button
              style={{
                backgroundColor: "#1769b3",
                borderColor: "#1769b3",
                color: "white",
              }}
              onClick={() => navigate("/qna/write")}
            >
              글작성
            </Button>
          </Col>
        </Row>

        {/* 페이지네이션 */}
        <Pagination className="justify-content-center mt-4">
          <Pagination.First
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          />
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {Array.from({ length: totalPages }, (_, i) => (
            <Pagination.Item
              key={i + 1}
              active={i + 1 === currentPage}
              onClick={() => handlePageChange(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
          <Pagination.Last
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </SidebarLayout>
    </div>
  );
}
